export interface Viewport {
  width: number
  height: number
}

export interface FieldEntry {
  key: string
  value?: string
  region?: string
}

export interface Box {
  key: string
  x: number
  y: number
  w: number
  h: number
  region: string
}

export function escapeXml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
}

export function buildSnapshotXml(params: {
  pageKey: string
  pageUrl: string
  pageTitle: string
  createdAtIso: string
  fields: FieldEntry[]
  viewport?: Viewport
}): string {
  const { pageKey, pageUrl, pageTitle, createdAtIso, fields, viewport } = params

  const head = `<snapshot page_key="${pageKey}" page_url="${pageUrl}" page_title="${escapeXml(
    pageTitle
  )}" created_at="${createdAtIso}">`

  const vp = viewport
    ? `  <viewport width="${viewport.width}" height="${viewport.height}" />\n`
    : ""

  const fieldsXml =
    "  <fields>\n" +
    fields
      .map((f) => {
        const regionAttr = f.region ? ` region="${f.region}"` : ""
        const val =
          f.value !== undefined ? `<value>${escapeXml(f.value)}</value>` : ""
        return `    <field key="${f.key}"${regionAttr}>${val}</field>`
      })
      .join("\n") +
    "\n  </fields>\n"

  // Layout is deprecated in favor of per-field region attribute
  const layoutXml = ""

  // Visible labels are omitted to reduce payload size
  const labelsXml = ""

  const tail = "</snapshot>\n"
  return head + "\n" + vp + fieldsXml + layoutXml + labelsXml + tail
}

export function deriveRegion(
  viewport: Viewport,
  rect: { x: number; y: number; width: number; height: number }
): string {
  const cx = rect.x + rect.width / 2
  const cy = rect.y + rect.height / 2
  const thirdX = viewport.width / 3
  const thirdY = viewport.height / 3

  const col = cx < thirdX ? 0 : cx < 2 * thirdX ? 1 : 2
  const row = cy < thirdY ? 0 : cy < 2 * thirdY ? 1 : 2

  if (row === 0 && col === 0) return "top-left"
  if (row === 0 && col === 1) return "top-center"
  if (row === 0 && col === 2) return "top-right"
  if (row === 1 && col === 0) return "middle-left"
  if (row === 1 && col === 1) return "center"
  if (row === 1 && col === 2) return "middle-right"
  if (row === 2 && col === 0) return "bottom-left"
  if (row === 2 && col === 1) return "bottom-center"
  return "bottom-right"
}
